import axiosClient from "./axiosClient";


export const getCalendarStatus = async () => {
    try {
        const response = await axiosClient.get('/calendar/status');
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const connectCalendar = async () => {
    try {
        const response = await axiosClient.get('/calendar/connect');
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const disconnectCalendar = async () => {
    try {
        const response = await axiosClient.delete('/calendar/disconnect');
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const getCalendars = async () => {
    try {
        const response = await axiosClient.get('/calendar/calendars');
        return response.data.data.calendars;
    } catch (error) {
        throw error;
    }
};


export const connectCalendarWithCode = async (code) => {
    try {
        const response = await axiosClient.post('/accounts/me/calendar/google', {
            code,
            redirect_uri: `${window.location.origin}/accounts/me/calendar/google/callback`,
        });
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const getGoogleCalendarAuthUrl = async () => {
    try {
        const response = await axiosClient.post('/accounts/me/calendar/google');
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const getGoogleCalendarStatus = async () => {
    try {
        const response = await axiosClient.get('/accounts/me/calendar/google/status');
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const getGoogleCalendars = async () => {
    try {
        const response = await axiosClient.get('/accounts/me/calendar/google/calendars');
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const getChannelCalendarStatus = async (storeUuid, channelUuid) => {
    try {
        const response = await axiosClient.get(`/stores/${storeUuid}/channels/${channelUuid}/calendars/status`);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const createChannelCalendars = async (storeUuid, channelUuid, { target, sources }) => {
    try {
        const response = await axiosClient.post(`/stores/${storeUuid}/channels/${channelUuid}/calendars`, {
            target,
            sources,
        });
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const updateChannelCalendars = async (storeUuid, channelUuid, { target, sources }) => {
    try {
        const response = await axiosClient.put(`/stores/${storeUuid}/channels/${channelUuid}/calendars`, {
            target,
            sources,
        });
        return response.data.data;
    } catch (error) {
        throw error;
    }
};
